import type { ReactElement } from "react";

import { MarketingLayout } from "./sections/Layout";
import { Hero } from "./sections/Hero";
import { ExampleSites } from "./sections/ExampleSites";
import { HowItWorks } from "./sections/HowItWorks";
import { Features } from "./sections/Features";
import { Comparison } from "./sections/Comparison";
import { Pricing } from "./sections/Pricing";
import { Faq } from "./sections/Faq";
import { FinalCta } from "./sections/FinalCta";

export function Landing(): ReactElement {
  return (
    <MarketingLayout ambient>
      <Hero />
      <ExampleSites />
      <HowItWorks />
      <Features />
      <Comparison />
      <Pricing />
      <Faq />
      <FinalCta />
    </MarketingLayout>
  );
}
